var _rect, _path, _path2, _path3, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteIconWithBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 48,
    viewBox: "0 0 52 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "delete-svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 47,
    rx: 7.5,
    fill: "#EEF5FF",
    className: "delete-svg"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5798 20.3818C33.5798 20.3818 33.018 27.35 32.6921 30.2852C32.5369 31.6871 31.6709 32.5086 30.2524 32.5345C27.5531 32.5831 24.8507 32.5862 22.1524 32.5293C20.7877 32.5014 19.9362 31.6695 19.7841 30.2925C19.4562 27.3314 18.8975 20.3818 18.8975 20.3818",
    stroke: "#0869FB",
    strokeWidth: 1.55193,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "delete-svg"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0109 17.0417H17.4658",
    stroke: "#0869FB",
    strokeWidth: 1.55193,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "delete-svg"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6305 17.0414C30.8184 17.0414 30.1189 16.4672 29.9596 15.6716L29.7082 14.4135C29.553 13.8331 29.0274 13.4316 28.4284 13.4316H24.0488C23.4498 13.4316 22.9242 13.8331 22.769 14.4135L22.5176 15.6716C22.3583 16.4672 21.6589 17.0414 20.8467 17.0414",
    stroke: "#0869FB",
    strokeWidth: 1.55193,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "delete-svg"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 47,
    rx: 7.5,
    stroke: "#0869FB",
    className: "delete-svg"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconWithBorder);
export default __webpack_public_path__ + "static/media/DeleteIconWithBorder.5dd4215e42285fc0df1038f6e446ed72.svg";
export { ForwardRef as ReactComponent };